import { useSnapshot } from "valtio";
import { useEffect } from "react";
import apiData from "lib/stores/apiData";
import mapData from "lib/stores/mapData";
import context from "lib/stores/context";
import setURLHash from "lib/helpers/setURLHash";

export default function useSyncURLHash() {
  const { fetchingTopLevelData } = useSnapshot(apiData);
  const { activeRegion, activeView, activeCountry, activeTabWorldwide, activeTabCountries, activeTabRegions, mode } = useSnapshot(context);
  const { selectedProduct, activeCategory, showProducts, productsCountry } = useSnapshot(mapData);

  useEffect(() => {
    if (fetchingTopLevelData) return;
    if (mode === "map") {
      setURLHash();
    }
  }, [
    activeRegion,
    activeCategory,
    activeView,
    activeCountry,
    activeTabWorldwide,
    activeTabCountries,
    activeTabRegions,
    selectedProduct,
    showProducts,
    productsCountry
  ]);
}
